var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2076,
    height: 2923,
    transform: "translate(-696 -1991)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 33.598 33.598 43 22 43C10.402 43 1 33.598 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22Z",
    stroke: "#C5C9DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C19.2311 8 16.5243 8.82109 14.222 10.3594C11.9197 11.8978 10.1253 14.0843 9.06569 16.6424C8.00607 19.2006 7.72882 22.0155 8.26901 24.7313C8.80921 27.447 10.1426 29.9416 12.1005 31.8995C14.0584 33.8574 16.553 35.1908 19.2687 35.731C21.9845 36.2712 24.7994 35.9939 27.3576 34.9343C29.9157 33.8747 32.1022 32.0803 33.6406 29.778C35.1789 27.4757 36 24.7689 36 22C35.9956 18.2883 34.5192 14.7299 31.8947 12.1053C29.2701 9.48078 25.7117 8.00438 22 8ZM26.718 26.718C26.4793 26.9566 26.1557 27.0906 25.8182 27.0906C25.4807 27.0906 25.157 26.9566 24.9184 26.718L21.1002 22.8998C20.8615 22.6612 20.7273 22.3375 20.7273 22V14.3636C20.7273 14.0261 20.8614 13.7024 21.1 13.4637C21.3387 13.225 21.6625 13.0909 22 13.0909C22.3376 13.0909 22.6613 13.225 22.9 13.4637C23.1386 13.7024 23.2727 14.0261 23.2727 14.3636V21.4731L26.718 24.9184C26.9566 25.157 27.0906 25.4807 27.0906 25.8182C27.0906 26.1557 26.9566 26.4793 26.718 26.718Z",
    fill: "#258E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.746f0f783bc68fbac72b4dbbff0d404a.svg";
export { ForwardRef as ReactComponent };